import type { IUser } from 'types/user'

type UsuarioDaSessao = { organization?: IUser['organization'] | null }

// why: sem organização escolhida, as consultas da barra lateral (get-menu,
// organizations/list) saíam com token sem organização. Mesmo critério do
// processAuthentication do login (auth.tsx), que já não autenticava sem ela.
export const sessaoPronta = (user: UsuarioDaSessao | null | undefined, token: string): boolean =>
  !!user && !!token && !!user.organization
